import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CASE_STUDIES } from "@/data/caseStudies";
import SEO from "@/components/SEO";

export default function Blog() {
  const articles = CASE_STUDIES;
  return (
    <section className="section-pad">
      <SEO
        path="/casistudio"
        title="Casi Studio — Storie di trasformazione aziendale"
        description="Casi studio reali di aziende trasformate con il Metodo A.L.L.I.N.E.A. di Roberta Castagna: hospitality, internazionalizzazione, brand identity per turismo luxury. Dallo stato iniziale al risultato ingegnerizzato."
      />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16" data-reveal>
          <p className="eyebrow mb-4">Casi Studio</p>
          <h1 className="font-display text-5xl sm:text-6xl leading-tight text-[#2A3229]">Storie, riflessioni e casi <span className="text-[#323C36]">dal campo</span></h1>
        </div>
        <div className="grid md:grid-cols-3 gap-10">
          {articles.map((a, i) => (
            <Link
              data-testid={`article-${a.id}`}
              to={`/casistudio/${a.slug}`}
              key={a.id}
              data-reveal
              data-reveal-delay={`${(i % 3) + 1}`}
              className="group flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden mb-5">
                <img src={a.cover} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <p className="eyebrow mb-2">{a.category}</p>
              <h2 className="font-display text-2xl text-[#2A3229] leading-snug group-hover:text-[#323C36] transition-colors mb-4">{a.title}</h2>

              {a.hook && (
                <div className="bg-[#EDE7DD] p-4 mb-4">
                  <div className="flex items-start gap-2 text-sm">
                    <span className="text-[#A8674F] font-semibold shrink-0">DA</span>
                    <span className="text-[#5A6058]">{a.hook.from}</span>
                  </div>
                  <div className="flex items-center justify-center my-1"><ArrowRight size={14} className="text-[#A8674F] rotate-90"/></div>
                  <div className="flex items-start gap-2 text-sm">
                    <span className="text-[#323C36] font-semibold shrink-0">A</span>
                    <span className="text-[#2A3229] font-medium">{a.hook.to}</span>
                  </div>
                </div>
              )}

              <p className="mt-2 text-xs uppercase tracking-widest text-[#A8674F]">Leggi il caso studio →</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
